import { Pie } from 'vue-chartjs'
import { stringToColor } from './stringToColor'

export default {
    extends: Pie,

    props: {
        questions: {
            type: Array
        }
    },

    methods: {
        getFields() {
            const fields = {}

            for (const question of this.questions) {
                const field = question.field.title

                if (! fields[field]) {
                    fields[field] = 0
                }

                fields[field]++
            }

            return fields
        },

        actualRender() {
            const fields = this.getFields()

            const backgrounds = []
            const labels = []
            const data = []

            for (const field in fields) {
                labels.push(`${field}: ${fields[field]}`)
                backgrounds.push(this.stringToColor(field))
                data.push(fields[field])
            }

            this.renderChart({
                labels: labels,
                datasets: [
                    {
                        data: data,
                        backgroundColor: backgrounds
                    }
                ],
            }, {
                legend: {
                    position: 'right',
                    labels: {
                        textAlign: 'right',
                        font: {
                            size: 14
                        }
                    }
                }
            })
        },
        render() {
            this.$nextTick(() => this.actualRender())
        },
        stringToColor
    },

    mounted() {
        this.render()
    }
}
